import { createIcon } from './createIcon';

/** Arrow into a tray — export / save the thing this row names. */
export const DownloadIcon = createIcon({
  name: 'DownloadIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <path
        d="M8 2v8M4.25 7l3.75 3.75L11.75 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 13.5h10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </>
  ),
});

export default DownloadIcon;
